<template>
  <v-row dense no-gutters align="center" justify="center" class="fill-height">
    <v-col class="fill-height">
      <v-row v-if="title && title !== ''" dense no-gutters align="center" justify="center" class="fill-height">
        <v-icon small v-if="icon" :color="color">
          {{ icon }}
        </v-icon>
        <span :class="'text-center px-2 ' + font">
          {{ title }}
        </span>
      </v-row>
      <v-row
        dense
        no-gutters
        align="center"
        justify="center"
        class="fill-height text-truncate d-flex justify-space-around"
      >
        <v-col
          cols="12"
          style="display: block"
          :class="`align-center big-number-container justify-center text-center text-truncate px-0 ${valueFont}`"
          @click.stop="clickBigNumber"
        >
          <v-icon v-if="!!bigIcon" left :color="bigIconColor" :size="bigIconSize">{{ bigIcon }}</v-icon>
          <template v-if="!isNaN(Number(this.value)) || this.mode !== 'numeric'">
            <span :style="valueFontColor ? `color:${valueFontColor}` : ''">
              {{ valuePrefix }}{{ bigNumber }}{{ valueSuffix }}
            </span>
          </template>
          <v-icon
            v-else-if="isNaN(Number(this.value)) && this.mode === 'numeric'"
            right
            color="grey lighten-3"
            :size="88"
            >fa-regular fa-empty-set</v-icon
          >
        </v-col>
      </v-row>
      <v-row v-if="subtitle !== ''" dense no-gutters align="center" justify="center" class="fill-height">
        <div :class="'align-center justify-center text-center px-0 ' + subtitleFont">
          {{ subtitle }}
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import approx from 'approximate-number'

export default {
  name: 'BigNumber',
  props: {
    color: {
      type: String,
      description: 'Color of the icon',
      default: 'red'
    },
    icon: {
      type: String,
      description: 'Icon to display'
    },
    title: {
      type: String,
      description: 'Title of the item',
      default: ''
    },
    mode: {
      type: String,
      description: 'Numeric or string mode',
      default: 'numeric'
    },
    font: {
      type: String,
      description: 'Font class for title',
      default: 'title'
    },
    valueFont: {
      type: String,
      description: 'Font class for number',
      default: 'display-4'
    },
    valueFontColor: {
      type: String,
      default: null
    },
    value: {
      description: 'Number/letter to display'
    },
    valuePrefix: {
      type: String,
      description: 'String to prepend to the value display.'
    },
    valueSuffix: {
      type: String,
      description: 'String to append to the value display.'
    },
    subtitle: {
      type: String,
      description: 'Subtitle of the item',
      default: ''
    },
    subtitleFont: {
      type: String,
      description: 'Subtitle font',
      default: 'subtitle-2'
    },
    bigIcon: {
      type: String,
      description: 'Big icon to display',
      default: null
    },
    bigIconColor: {
      type: String,
      description: 'Big icon color',
      default: 'primary'
    },
    bigIconSize: {
      type: Number,
      description: 'Big icon size',
      default: 78
    },
    to: {
      type: String,
      description: 'Link'
    }
  },
  computed: {
    bigNumber() {
      if (this.mode === 'numeric') {
        return approx(Number(this.value))
      } else {
        return this.value
      }
    }
  },
  methods: {
    clickBigNumber(e) {
      if (!this.to) {
        this.$emit('click', e)
        return
      }

      this.$router.push(this.to)
    }
  }
}
</script>
